import { useI18n } from 'i18n-utils'
import { DefineComponentProps } from 'utils'
import { HocElDialog } from '../hoc-element-components/HocElDialog'
import { CustomButton } from './Button'
import { DialogHeader } from './DialogHeader'
import './KycVerifyDialog.scss'

export type KycVerifyDialogProps = {
  onClose?: () => void
  onConfirm?: () => void
}

export const KycVerifyDialog = defineComponent<KycVerifyDialogProps>({
  props: DefineComponentProps<KycVerifyDialogProps>(['onClose', 'onConfirm']),
  setup(props) {
    const { t } = useI18n()
    const visible = ref(true)

    const handleClose = () => {
      visible.value = false
    }

    const handleConfirm = () => {
      visible.value = false
      setTimeout(() => {
        props.onConfirm?.()
      }, 300)
    }

    watch(
      () => visible.value,
      (value) => {
        if (!value) {
          setTimeout(() => {
            props.onClose?.()
          }, 300)
        }
      },
    )

    return () => (
      <HocElDialog v-model={visible.value} width={480} showClose={false} closeOnClickModal={false}>
        {{
          header: () => <DialogHeader onClose={handleClose}>{t('需要身份认证')}</DialogHeader>,
          default: () => (
            <div class="kyc-verify-dialog-layout">
              <div class="content">{t('需完成身份认证，才可以使用此功能。快前往认证吧~')}</div>
              <CustomButton size="medium" isFull type="primary" onClick={handleConfirm}>
                {t('去认证')}
              </CustomButton>
            </div>
          ),
        }}
      </HocElDialog>
    )
  },
})
